export enum Toggles {
  SEND_SNOWPLOW_EVENTS = 'SEND_SNOWPLOW_EVENTS',
  ASSESSMENTS = 'AYLA_ASSIGNMENT',
  OVERRIDE_PROVIDER_UI_RULES = 'OVERRIDE_PROVIDER_UI_RULES',
}
